import styled from "styled-components";
import TagText from "../../ui/Tags/TagText";

export default styled(TagText)`
  display: inline-block;
  margin-left: 16px;
  align-self: center;
`;
